import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ig_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') || error.config?.url?.includes('/auth/register');
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('ig_token');
      localStorage.removeItem('ig_user');
      window.location.href = `${process.env.PUBLIC_URL}/signin`;
    }
    return Promise.reject(error);
  }
);

export const plansAPI = {
  getAll: () => api.get('/plans'),
  getById: (id) => api.get(`/plans/${id}`),
};

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  upgrade: (paymentReference) => api.post('/auth/upgrade-plan', { paymentReference }),
};

export const paymentAPI = {
  process: (data) => api.post('/payment/process', data),
  status: (ref) => api.get(`/payment/check/${ref}`),
  countries: () => api.get('/payment/countries'),
};

export const contentAPI = {
  getAll: () => api.get('/content'),
  catalog: () => api.get('/content/catalog'),
};

export default api;
